
import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormRecentWorks from './FormRecentWorks'
import { InitialValues, getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { usePageState } from '../../lib/state mangment/LayoutPagestate'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useUpdateRecentWorks } from '../../api/RecentWorks'

function EditRecentWorksModal() {
  const {objectToEdit} = usePageState()
  const {status, mutate} = useUpdateRecentWorks();

  const handleSubmit = (value:InitialValues)=>{
    const dataToSend = getDataToSend({...value})
    
    mutate(dataToSend)
}
  
  return (
    <LayoutModal 
     isAddModal={false}
     getInitialValues={getInitialValues(objectToEdit)} 
     handleSubmit={handleSubmit}
     status={status as QueryStatusEnum}
     headerText='Edit Modal' 
     getValidationSchema={getValidationSchema(objectToEdit)}>
      <FormRecentWorks />
    </LayoutModal>
  )
}

export default EditRecentWorksModal
